import type { InternalAxiosRequestConfig } from 'axios';

// 🚀 导入mock数据
import authMockResponse from '../api/auth/__mock__/auth.mock';
import chatMockResponse from '../api/chat/__mock__/chat.mock';
import faqMockResponse from '../api/faq/__mock__/faq.mock';
import { settingMockResponses, updateShopSettingsMockResponses } from '../api/setting/__mock__/setting.mock';

// API 基础路径
const apiVersion = '/api/brand/v1/';

// 合并所有mock响应
const mockResponse: Record<string, unknown> = {
  ...authMockResponse,
  ...chatMockResponse,
  ...faqMockResponse,
  ...settingMockResponses,
  ...updateShopSettingsMockResponses
};

/**
 * 判断是否启用 mock 模式
 * @returns boolean 是否启用 mock 模式
 */
export const isMockEnabled = (): boolean => {
  const enabled = false;
  return enabled;
};

/**
 * 获取 mock 模式下的 API 基础 URL
 * @returns string API 基础 URL
 */
export const getMockBaseUrl = (): string => {
  return '';
};

/**
 * 创建默认的 mock 响应数据
 * @returns object 默认的 mock 响应数据
 */
export const createDefaultMockResponse = (): unknown => {
  return {
    code: 0,
    msg: 'success (default mock response)',
    data: {},
    time: Date.now(),
    requestId: `mock-${Date.now()}`,
    reasonCode: 0,
    requiredVersion: {
      clientWeb: '1.0.0',
      merchantWeb: '1.0.0'
    }
  };
};

/**
 * 处理 mock 请求
 * @param config Axios 请求配置
 * @returns InternalAxiosRequestConfig | null 处理过的配置或 null (表示不需要 mock)
 */
export const handleMockRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig | null => {
  // 如果未启用 mock 或没有 URL，则不处理
  if (!isMockEnabled() || !config.url) {
    return null;
  }

  // 构建 mock 数据路径
  const mockPath = apiVersion + config.url;
  console.log('尝试查找 mock 数据路径:', mockPath);

  // 查找匹配的 mock 数据
  const mockData = mockResponse[mockPath];

  // 如果找到匹配的 mock 数据
  if (mockData) {
    console.log('找到 mock 数据:', mockPath, mockData);
    // 创建一个适配器来返回 mock 数据
    const responseTimeout = 9000;
    config.adapter = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            data: mockData,
            status: 200,
            statusText: 'OK',
            headers: {},
            config,
          });
        }, responseTimeout);
      });
    };
  } else {
    // 没有找到匹配的 mock 数据
    console.warn('未找到匹配的 mock 数据:', mockPath, '可用的 mock 路径:', Object.keys(mockResponse));
    
    // 提供默认的成功响应，避免发送真实请求
    config.adapter = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            data: createDefaultMockResponse(),
            status: 200,
            statusText: 'OK',
            headers: {},
            config,
          });
        }, 300);
      });
    };
  }

  return config;
};

// 导出 API 版本和 mock 数据，方便在其他地方使用
export const getApiVersion = (): string => { return apiVersion };
export const mockData = mockResponse;
